import React from 'react';

const formatLine = (line, lineIndex) => {
	const parts = [];
	let lastIndex = 0;
	let match;
	const boldPattern = /\*\*(.+?)\*\*/g;

	while ((match = boldPattern.exec(line)) !== null) {
		if (match.index > lastIndex) {
			parts.push(line.slice(lastIndex, match.index));
		}
		parts.push(
			<strong key={`${lineIndex}-${match.index}`} className='font-semibold text-gray-800'>
				{match[1]}
			</strong>
		);
		lastIndex = match.index + match[0].length;
	}

	if (lastIndex < line.length) {
		parts.push(line.slice(lastIndex));
	}

	return parts.length ? parts : line;
};

export const formatApiDocText = (text) => {
	if (!text) return null;

	const lines = text.split('\n');

	return lines.map((line, lineIndex) => (
		<React.Fragment key={lineIndex}>
			{formatLine(line, lineIndex)}
			{lineIndex < lines.length - 1 && <br />}
		</React.Fragment>
	));
};
